export default (that) => [
  {
    text: that.$l('menu_text_replyEdit') || '返答填写',
    icon: 'el-icon-edit',
    menuType: 'replyEdit',
  },
  {
    text: that.$l('menu_text_submit') || '提交运营确认',
    icon: 'el-icon-check',
    menuType: 'submit',
    disabled: ({ approvalStatus }) => approvalStatus !== 'C' || that.disabled,
  },
]
